// extracted by mini-css-extract-plugin
module.exports = {"legacyContent":"style_legacyContent__HQ__0 style_contentLane__8yFN3"};